import { useOutletContext } from 'react-router-dom'
import type { SiteContext } from '../components/MainLayout'
import { StaggerGroup } from '../components/motion'
import PortfolioCard from '../components/PortfolioCard'
import { CallToAction, PageIntro } from '../components/ui'
import { routeFor } from '../config/routes'
import { siteConfig } from '../config/site'
import { usePageMeta } from '../hooks/usePageMeta'

export default function PortfolioPage() {
  const { language, copy } = useOutletContext<SiteContext>()
  const page = copy.portfolio
  usePageMeta({ language, title: page.eyebrow, description: page.intro })
  return <><PageIntro eyebrow={page.eyebrow} title={page.title} text={page.intro} /><section className="section portfolio-page"><StaggerGroup className="shell portfolio-grid portfolio-grid--full">{siteConfig.portfolio.map((project, index) => <PortfolioCard key={project.id} language={language} project={project} index={index} />)}</StaggerGroup></section><CallToAction eyebrow="FOTIS MYTIKAS / DIGITAL SERVICES" title={page.ctaTitle} text={page.ctaText} button={copy.common.requestQuote} to={routeFor(language, 'contact')} /></>
}
